import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  Checkbox,
  Tooltip,
  InputBase,
  Grid,
  useMediaQuery,
  DialogActions,
  Alert,
  Snackbar,
} from "@mui/material";
import { BiSolidEdit } from "react-icons/bi";
import { MdOutlineDelete } from "react-icons/md";
import { AiOutlineEye } from "react-icons/ai";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import CustomPagination from "./CustomPagination";
import {
  delete_template,
  get_all_templates,
  get_template,
} from "../Api service/APIvariables";
import DialogModal from "./DialogModal";
import SnackBar from "./SnackBar";

const TemplateTable = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templatesOne, setTemplatesOne] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [search, setSearch] = useState("");
  const [noDataFound, setNoDataFound] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editedTemplate, setEditedTemplate] = useState({
    name: "",
    action: "",
  });
  const [isAddTemplate, setIsAddTemplate] = useState(false);
  const [deleteTemplateId, setDeleteTemplateId] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [viewTemplate, setViewTemplate] = useState(null);
  const [hashReadOnlyButton, setHashReadOnlyButton] = useState(false);

  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(false);
  const [color, setColor] = useState(false);
  const [message, setMessage] = useState("");

  const handleCloseViewDialog = () => {
    setOpenViewDialog(false);
    setViewTemplate(null);
  };

  // Function to handle opening view dialog
  const handleOpenViewDialog = (template) => {
    setViewTemplate(template);
    setOpenViewDialog(true);
  };

  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Search state
  const [searchQuery, setSearchQuery] = useState("");

  // Media query for detecting screen size (mobile vs desktop)
  const isMobile = useMediaQuery("(max-width:768px)");

  const navigate = useNavigate();
  const isAdmin = window.location.pathname.startsWith("/admin");

  const handleNavigateToTemplate = () => {
    navigate(isAdmin ? "/admin/create-template" : "/template");
  };

  // GET ALL TEMPLATE api call
  const fetchTemplates = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const formData = new FormData();
      formData.append("user_id", user_id);
      // formData.append("template_id", templateId);

      const token = localStorage.getItem("auth_token");
      // console.log(token);

      const response = await fetch(get_all_templates, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch templates");
      }

      const result = await response.json();

      if (result.data) {
        let flatTemplates = [];
        
        if (result.data.user_templates && result.data.user_templates.length > 0) {
            flatTemplates = [...flatTemplates, ...result.data.user_templates.map(t => ({...t, template_name: `[Custom] ${t.template_name}`}))];
        }
        if (result.data.free && result.data.free.length > 0) {
            flatTemplates = [...flatTemplates, ...result.data.free.map(t => ({...t, template_name: `[Free] ${t.template_name}`}))];
        }
        if (result.data.plus && result.data.plus.length > 0) {
            flatTemplates = [...flatTemplates, ...result.data.plus.map(t => ({...t, template_name: `[Plus] ${t.template_name}`}))];
        }
        if (result.data.pro && result.data.pro.length > 0) {
            flatTemplates = [...flatTemplates, ...result.data.pro.map(t => ({...t, template_name: `[Pro] ${t.template_name}`}))];
        }
        if (result.data.unlimited && result.data.unlimited.length > 0) {
            flatTemplates = [...flatTemplates, ...result.data.unlimited.map(t => ({...t, template_name: `[Unlimited] ${t.template_name}`}))];
        }

        if (flatTemplates.length > 0) {
          const templatesWithIds = flatTemplates.reverse().map((row, index) => ({
            ...row,
            generatedId: index + 1,
          }));
          setTemplates(templatesWithIds);
          setTemplatesOne(templatesWithIds);
        } else {
          setTemplates([]);
          setTemplatesOne([]);
        }
      } else {
        setTemplates([]);
        setTemplatesOne([]);
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
      setLoading(false); // You may want to set loading to false here too
    }
  };
  // console.log(templatesOne);
  useEffect(() => {
    fetchTemplates();
  }, []);

  // Single Template Get API Call
  const fetchSingleTemplate = async (template_id) => {
    try {
      const user_id = localStorage.getItem("user_id");
      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("template_id", template_id);
      const token = localStorage.getItem("auth_token");
      // console.log(token);

      const response = await fetch(get_template, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch templates");
      }

      const result = await response.json();

      if (result.data && result.data.length > 0) {
        // Add a unique incremental ID to each template

        setTemplates(result.data);
        setTemplatesOne(result.data);
      } else {
        // Handle case when there are no templates
        // console.log("No templates found:", result.message);
        // setTemplates([]);
        // setTemplatesOne([]);
        // Optionally show a message to the user or update state for no data
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
      setLoading(false); // You may want to set loading to false here too
    }
  };
  // console.log(templatesOne);
  useEffect(() => {
    fetchSingleTemplate();
  }, []);

  // API call for Delete Function
  const handleDelete = async (id) => {
    // Retrieve the necessary user_id and auth token from localStorage
    const userId = localStorage.getItem("user_id");
    const token = localStorage.getItem("auth_token");
    if (!userId || !token) {
      setMessage("User ID or Token is missing!");
      setOpen(true);
      setColor(false);
      setStatus(false);
      return;
    }

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("template_id", id);

    try {
      const response = await fetch(delete_template, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`, // Pass the token in the Authorization header
        },
        body: formData, // Send the form data in the request body
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("Template deleted successfully!");
        setOpen(true);
        setColor(true);
        setStatus(true);
        // setTemplates((prevTemplates) =>
        //   prevTemplates.filter((template) => template.id !== id)
        // );
        fetchTemplates();
      } else {
        setMessage(`Error: ${data?.message || "Unknown error"}`);
        setOpen(true);
        setColor(false);
        setStatus(false);
      }
    } catch (error) {
      setMessage(`Error during deletion: ${error.message}`);
      setOpen(true);
      setColor(true);
      setStatus(true);
    } finally {
      setIsSubmitting(false);
      handleCloseDelete();
    }
  };

  const handleOpenDialog = (template_id) => {
    setSelectedTemplateId(template_id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleSave = () => {
    if (isAddTemplate) {
      const newTemplate = {
        id: templates.length + 1,
        name: editedTemplate.name,
        action: "",
      };
      setTemplates([...templates, newTemplate]);
      setMessage("Template added successfully!");
      setStatus(true);
      setColor("success");
    } else {
      const updatedTemplates = templates.map((template) =>
        template.id === selectedTemplate.id
          ? {
              ...template,
              name: editedTemplate.name,
              subject: editedTemplate.subject,
              message: editedTemplate.message,
              action: editedTemplate.action,
            }
          : template
      );
      setTemplates(updatedTemplates);
      setMessage("Template updated successfully!");
      setStatus(true);
      setColor("info");
    }
    setOpenDialog(false);
    setOpen(true);
  };

  const [statusMessage, setStatusMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleView = (template) => {
    setViewTemplate(template);
    setOpenViewDialog(true);
  };

  const handleCheckboxChange = (id) => {
    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.includes(id)
        ? prevSelectedRows.filter((rowId) => rowId !== id)
        : [...prevSelectedRows, id]
    );
    console.log(id);
    console.log(selectedRows);
  };

  const handleDeleteAll = async (id) => {
    const userId = localStorage.getItem("user_id");
    const token = localStorage.getItem("auth_token");

    if (!userId || !token) {
      setStatusMessage("User ID or Token is missing!");
      return;
    }

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("template_id", id); // Append the template_id to be deleted

    try {
      const response = await fetch(delete_template, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`, // Pass the token in the Authorization header
        },
        body: formData, // Send the form data in the request body
      });

      const data = await response.json();

      if (response.ok && !data.error) {
        setStatusMessage("Template deleted successfully!");
        setOpen(true);
        setColor(true);
        setStatus(true);
        setTemplates((prevTemplates) =>
          prevTemplates.filter((template) => template.id !== id)
        );
      } else {
        setStatusMessage(`Error: ${data?.message || data?.mysql_error || "Unknown error"}`);
        setOpen(true);
        setColor(false);
        setStatus(false);
      }
    } catch (error) {
      setStatusMessage(`Error during deletion: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };
  // useEffect(() => {
  //   handleDeleteAll();
  // }, []);

  const handleDeleteSelected = () => {
    const filteredTemplates = templates.filter(
      (template) => !selectedRows.includes(template.id)
    );
    setTemplates(filteredTemplates);
    setSelectedRows([]);
    setMessage("Selected templates deleted!");
    setStatus(true);
    setColor("error");
    setOpen(true);
  };

  // const DeleteConfirmation = ({ handleDelete, rowId }) => {
  const [openDelete, setOpenDelete] = useState(false);

  const handleOpenDelete = (rowId) => {
    setDeleteTemplateId(rowId);
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setDeleteTemplateId(false);
    setOpenDelete(false);
  };

  const handleConfirmDelete = () => {
    handleDelete(deleteTemplateId);
  };

  // Handle Pagination change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset page to 0 when changing rows per page
  };

  // Filter templates based on search query
  const searchFilter = () => {
    const filteredTemplates = templates.filter((template) =>
      template.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  };

  useEffect(() => {
    const searchQuery = search.trim().toLowerCase();

    if (searchQuery === "") {
      setTemplatesOne(templates);
    } else {
      const filteredTemplates = templatesOne.filter((row) => {
        if (!isNaN(searchQuery)) {
          return row.id === parseInt(searchQuery, 10);
        } else {
          return [
            "template_name",
            "subject",
            "message",
            "created_at",
            "updated_at",
          ].some((key) => row[key]?.toLowerCase().includes(searchQuery));
        }
      });

      setTemplatesOne(filteredTemplates);
      setNoDataFound(filteredTemplates.length === 0);
    }
  }, [search, templates]);

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(dateString).toLocaleString("en-US", options);
  };
  return (
    // <div>
    <Box
      style={{
        display: "block",
        backgroundColor: "#eceff1",
        minHeight: "100vh",
        // padding: "20px",
        position: "relative",
        width: "100%",
        // maxWidth: "98%",
        margin: "0 auto",
        // borderRadius: "30px",
        // paddingRight: "20px",
        paddingLeft: "20px",
        paddingRight: isMobile ? "15px" : "0px",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Snackbar
        open={open}
        autoHideDuration={4000}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity={status ? "success" : "error"}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>

      <Grid
        container
        spacing={2}
        sx={{ marginBottom: "20px", alignItems: "center" }}
      >
        {/* Create Template Button */}
        <Grid item xs={6} sm={6} md={6}>
          <Button
            variant="contained"
            onClick={handleNavigateToTemplate}
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#453c72",
              fontWeight: "bold",
              justifyContent: "center",
              padding: "6px 10px",
              fontSize: isMobile ? "10px" : "12px",
              minWidth: "unset",
              width: "auto",
              textTransform: "none",
            }}
          >
            {isMobile ? (
              <AddIcon sx={{ fontSize: "20px" }} />
            ) : (
              "Create Template"
            )}
          </Button>
        </Grid>

        {/* Search Bar & Actions */}
        <Grid
          item
          xs={6}
          sm={6}
          md={6}
          sx={{
            display: "flex",
            justifyContent: isMobile ? "flex-start" : "flex-end",
            alignItems: "center",
            gap: 2,
          }}
        >
          {selectedRows.length > 0 && (
            <Tooltip title="Delete Selected">
              <IconButton
                onClick={() => handleOpenDelete(selectedRows)}
                sx={{
                  backgroundColor: "#f44336",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#d32f2f" },
                  width: "40px",
                  height: "40px"
                }}
              >
                <MdOutlineDelete />
              </IconButton>
            </Tooltip>
          )}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#eceff1",
              borderRadius: "4px",
              width: isMobile ? "100%" : "200px", // Set width to 200px for desktop
              padding: "2px 10px",
              // boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              border: "1px solid #CFD8DC",
              transition: "all 0.3s ease-in-out", // Smooth transition for hover effects
              "&:hover": {
                // backgroundColor: "#dfe3e6", // Slightly darker background
                borderColor: "#1976d2", // Change border color on hover
                boxShadow: "0 4px 8px rgba(25, 118, 210, 0.2)",
              },
              "&:focus-within": {
                boxShadow: "0 4px 8px rgba(25, 118, 210, 0.2)",
                borderColor: "#1976d2", // Complementary active border color
              },
            }}
          >
            {/* <SearchIcon sx={{ color: "#212121" }} /> */}
            <InputBase
              sx={{
                ml: 1,
                flex: 1,
                color: "#212121",
                fontSize: "14px",
              }}
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Box>
        </Grid>
      </Grid>

      <TableContainer component={Paper} sx={{ marginTop: "20px" }}>
        <Table>
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: "#453c72",
                color: "white",
                fontWeight: 600,
              }}
            >
              <TableCell
                sx={{
                  fontSize: isMobile ? "12px" : "14px",
                  background: "#453c72",
                  color: "white",
                  fontWeight: 600,
                }}
              >
                <Checkbox
                  onChange={(e) =>
                    setSelectedRows(
                      e.target.checked
                        ? templates.map((template) => template.id)
                        : []
                    )
                  }
                  sx={{ color: "white" }}
                />
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  fontSize: isMobile ? "12px" : "14px",
                  backgroundColor: "#453c72",
                  color: "white",
                  fontWeight: 600,
                }}
              >
                No.
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  fontSize: isMobile ? "12px" : "14px",
                  backgroundColor: "#453c72",
                  color: "white",
                  fontWeight: 600,
                }}
              >
                Template Name
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  fontSize: isMobile ? "12px" : "14px",
                  backgroundColor: "#453c72",
                  color: "white",
                  fontWeight: 600,
                }}
              >
                Subject
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  fontSize: isMobile ? "12px" : "14px",
                  backgroundColor: "#453c72",
                  color: "white",
                  fontWeight: 600,
                }}
              >
                Message
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  fontSize: isMobile ? "12px" : "14px",
                  backgroundColor: "#453c72",
                  color: "white",
                  fontWeight: 600,
                }}
              >
                Date & Time
              </TableCell>
              {/* <TableCell
                align="center"
                sx={{
                  fontSize: isMobile ? "12px" : "14px",
                  backgroundColor: "#453c72",
                  color: "white",
                }}
              >
                Latest Time
              </TableCell> */}
              <TableCell
                align="center"
                sx={{
                  fontSize: isMobile ? "12px" : "14px",
                  backgroundColor: "#453c72",
                  color: "white",
                  fontWeight: 600,
                }}
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {templatesOne
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((template, index) => (
                <TableRow
                  key={template.generatedId}
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f3f3f3",
                  }}
                >
                  <TableCell sx={{ fontSize: isMobile ? "12px" : "14px" }}>
                    <Checkbox
                      checked={selectedRows.includes(template.id)}
                      onChange={() => handleCheckboxChange(template.id)}
                    />
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontSize: isMobile ? "12px" : "14px" }}
                  >
                    {/* {String(template.generatedId).padStart(3, "0")} */}
                    {template.generatedId}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontSize: isMobile ? "12px" : "14px" }}
                  >
                    {template.template_name}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontSize: isMobile ? "12px" : "14px" }}
                  >
                    {template.subject}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontSize: isMobile ? "12px" : "14px",
                      maxWidth: "200px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {template.message}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontSize: isMobile ? "12px" : "14px" }}
                  >
                    {template.updated_at
                      ? formatDate(template.updated_at)
                      : template.created_at
                        ? formatDate(template.created_at)
                        : "N/A"}
                  </TableCell>
                  {/* <TableCell
                    align="center"
                    sx={{ fontSize: isMobile ? "12px" : "14px" }}
                  >
                    {template.updated_at}
                  </TableCell> */}
                  <TableCell
                    align="center"
                    sx={{ fontSize: isMobile ? "12px" : "14px" }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 1,
                      }}
                    >
                      <Tooltip title="View">
                        <IconButton
                          onClick={() => {
                            setHashReadOnlyButton(true);
                            handleOpenDialog(template.id);
                          }}
                        >
                          <AiOutlineEye
                            style={{ fontSize: "20px", color: "black" }}
                          />
                        </IconButton>
                      </Tooltip>
                      {(!template.is_system || isAdmin) && (
                        <>
                          <Tooltip title="Edit">
                            <IconButton
                              onClick={() => handleOpenDialog(template.id)}
                            >
                              <BiSolidEdit
                                style={{ fontSize: "20px", color: "blue" }}
                              />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <IconButton
                              onClick={() => handleOpenDelete(template.id)}
                              color="error"
                            >
                              <MdOutlineDelete
                                style={{ fontSize: "20px", color: "red" }}
                              />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Edit Template */}
      <DialogModal
        openDialog={openDialog}
        hashReadOnlyButton={hashReadOnlyButton}
        setHashReadOnlyButton={setHashReadOnlyButton}
        setOpenDialog={setOpenDialog}
        fetchTemplates={fetchTemplates}
        template_id={selectedTemplateId} // Pass the selected template ID as a prop
        setOpen={setOpen}
        setMessage={setMessage}
        setStatus={setStatus}
        setColor={setColor}
      />

      <div
        style={{
          display: "flex",
          width: isMobile ? "100%" : "40%",
          justifyContent: "flex-end",
          alignItems: "center",
          marginLeft: "auto",
        }}
      >
        <CustomPagination
          count={templatesOne?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            fontSize: { xs: "10px", sm: "14px", md: "14px" },
            width: "auto",
            justifyContent: "space-between",
            marginBottom: 2,
          }} // smaller font size for pagination
        />
      </div>

      {/* Delete Confirmation modal */}
      <Dialog open={openDelete} onClose={handleCloseDelete}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <IconButton
          onClick={handleCloseDelete}
          sx={{
            position: "absolute",
            top: "10px",
            right: "10px",
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContent>
            Are you sure you really want to delete this file?
          </DialogContent>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseDelete}
            color="primary"
            // sx={{ backgroundColor: "gray", color: "white" }}
          >
            No
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Template Dialog */}
      <div>
        <Dialog
          open={openViewDialog}
          onClose={handleCloseViewDialog}
          sx={{ width: "100%", height: "100%" }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
            }}
          >
            Template Details
          </DialogTitle>
          <IconButton
            onClick={handleCloseViewDialog}
            sx={{
              position: "absolute",
              top: "10px",
              right: "10px",
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            {/* <Button>Edit</Button> */}
            {viewTemplate ? (
              <div>
                {true ? (
                  <>
                    <p>Template Name: {viewTemplate.template_name}</p>
                    <p>Subject: {viewTemplate.subject}</p>
                    <p> Message: {viewTemplate.message}</p>
                  </>
                ) : (
                  <DialogModal
                    openDialog={true}
                    hashReadOnlyButton={hashReadOnlyButton}
                    setOpenDialog={setOpenDialog}
                    fetchTemplates={fetchTemplates}
                    template_id={viewTemplate.template_id} // Pass the selected template ID as a prop
                    setOpen={setOpen}
                    setMessage={setMessage}
                    setStatus={setStatus}
                    setColor={setColor}
                  />
                )}
              </div>
            ) : (
              <p>Loading...</p>
            )}
          </DialogContent>
        </Dialog>
      </div>
    </Box>
    // </div>
  );
};

export default TemplateTable;
